import React from "react";
import { Form, Button, Dropdown } from "react-bootstrap";

/**
 * @typedef {"mom" | "yoy" | "cumulative"} StockCompareMode
 */

//  * @property {StockCompareMode} compare
//  * @property {(c: StockCompareMode) => void} setCompare

/**
 * @typedef {Object} StockFilterBarProps
 * @property {import("../../../components/dashboard/Sidebar").ReportKey} report
 * @property {number} months
 * @property {(m: number) => void} setMonths
 * @property {string} today
 * @property {string} oneYearAgo
 * @property {string} startDate
 * @property {(s: string) => void} setStartDate
 * @property {string} endDate
 * @property {(s: string) => void} setEndDate
 * @property {string} store
 * @property {number} storeId
 * @property {(s: string) => void} setStore
 * @property {(s: number) => void} setStoreId
 * @property {import("../../../models/StoreModel").StoreModel[]} stores
 * @property {string} category
 * @property {string} categoryId
 * @property {(c: string) => void} setCategory
 * @property {(c: string) => void} setCategoryId
 * @property {import("../../../models/CategoryModel").CategoryModel[]} categories
 * @property {() => void} onRefresh
 */

/**
 * @param {StockFilterBarProps} props
 */
export function StockFilterBar({
  report,
  months,
  setMonths,
  // compare,
  // setCompare,

  today,
  oneYearAgo,
  startDate,
  setStartDate,
  endDate,
  setEndDate,

  store,
  storeId,
  setStore,
  setStoreId,
  stores,
  category,
  categoryId,
  setCategory,
  setCategoryId,
  categories,
  onRefresh,
}) {
  /** @type {{ label: string; value: number }[]} */
  const ranges = [
    { label: "3M", value: 3 },
    { label: "6M", value: 6 },
    { label: "12M", value: 12 },
  ];

  // /** @type {{ k: StockCompareMode; label: string }[]} */
  // const compareOptions = [
  //   { k: "mom", label: "MoM" },
  //   { k: "yoy", label: "YoY" },
  //   { k: "cumulative", label: "Cumulative" },
  // ];

  return (
    <div className="pbi-filterbar">
      <div className="d-flex align-items-center gap-2 flex-wrap">
        <i className="bi bi-box-seam-fill text-warning" />
        <span className="fw-semibold me-2">Stock Filters</span>
        {/* <ButtonGroup size="sm">
          {ranges.map((r) => (
            <Button
              key={r.value}
              variant={months === r.value ? "warning" : "outline-secondary"}
              className={months === r.value ? "text-white" : ""}
              onClick={() => setMonths(r.value)}
            >
              {r.label}
            </Button>
          ))}
        </ButtonGroup> */}
        {/* <ButtonGroup size="sm">
          {compareOptions.map((c) => (
            <Button
              key={c.k}
              variant={compare === c.k ? "primary" : "outline-secondary"}
              onClick={() => setCompare(c.k)}
            >
              {c.label}
            </Button>
          ))}
        </ButtonGroup> */}

        {/* date */}
        {report === "stocks-closing" && (
          <div className="d-flex align-items-center gap-2">
            <Form.Control
              type="date"
              size="sm"
              style={{ width: 150 }}
              value={startDate}
              min={oneYearAgo}
              max={endDate || today}
              onChange={(e) => setStartDate(e.target.value)}
            />
            <span className="text-muted small">to</span>
            <Form.Control
              type="date"
              size="sm"
              style={{ width: 150 }}
              value={endDate}
              min={startDate || oneYearAgo}
              max={today}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
        )}

        {/*  */}
        <Dropdown>
          <Dropdown.Toggle size="sm" variant="outline-secondary">
            <i className="bi bi-shop me-1" />
            {store === "all" ? "All stores" : store}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => {
                setStore("all");
                setStoreId(-1);
              }}
            >
              All stores
            </Dropdown.Item>
            <Dropdown.Divider />
            {stores.map((s) => (
              <Dropdown.Item
                key={s.storecode}
                onClick={() => {
                  setStore(s.storename);
                  setStoreId(s.storecode);
                }}
              >
                {s.storename}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
        <Dropdown>
          <Dropdown.Toggle size="sm" variant="outline-secondary">
            <i className="bi bi-tags-fill me-1" />
            {category === "all" ? "All categories" : category}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => {
                setCategory("all");
                setCategoryId("-1");
              }}
            >
              All categories
            </Dropdown.Item>
            <Dropdown.Divider />
            {categories.map((c) => (
              <Dropdown.Item
                key={c.id}
                onClick={() => {
                  setCategory(c.name);
                  setCategoryId(c.id);
                }}
              >
                {c.name}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
        {/* <Form.Select size="sm" style={{ width: 160 }} defaultValue="all">
          <option value="all">All valuations</option>
          <option>FIFO</option>
          <option>Weighted Avg</option>
          <option>Standard Cost</option>
        </Form.Select> */}
      </div>
      <div className="d-flex align-items-center gap-2">
        <Button size="sm" variant="outline-secondary" onClick={onRefresh}>
          <i className="bi bi-arrow-clockwise" />
        </Button>
        <Button size="sm" variant="outline-secondary">
          <i className="bi bi-download me-1" />
          Export
        </Button>
      </div>
    </div>
  );
}
